import React from 'react';
import { Recommend } from '../../../../components';
export var RecommendCard = function (props) {
    var messageState = props.messageState;
    var _a = messageState.payload.message, message = _a === void 0 ? [] : _a;
    return (React.createElement(React.Fragment, null,
        React.createElement(Recommend, { message: message, type: 'guess-question-top' })));
};
